<template>
  <SplitViewTemplate
    :screenConfig="setScreenConfig"
    :backButtonRoute="'/settings/company'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      formModel: {
        IsDefault: "Y",
        SetAsPostalAddress: false,
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
        IsPostalData: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Branch",
        pageRoute: "/branch",
        saveEndPoint: "Save_Branch",
        recordEndPoint: "Branch",
        isDefaultEndPoint: "Save_DefaultBranch",
        exportFileName: "Branch List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BranchList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "branch",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: false,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/branch/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Branch",
              sortOrder: "asc",
              sortIndex: 0,
              dataField: "Code",
              gridDataField: "Code",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Branch Code",
                },
                {
                  dataField: "Description",
                  label: "Branch Description",
                },
              ],
            },
            {
              screenField: "StreetLine1",
              visible: false,
            },
            {
              screenField: "StreetLine2",
              visible: false,
            },
            {
              screenField: "Suburb",
              visible: false,
            },
            {
              screenField: "State",
            },
            {
              screenField: "PostCode",
            },
            {
              screenField: "Country",
            },
            {
              screenField: "StreetLine1",
              visible: false,
              dataField: "MailAddressStreetLine1",
              label: "Mail Street Line 1",
            },
            {
              screenField: "StreetLine2",
              visible: false,
              dataField: "MailAddressStreetLine2",
              label: "Mail Street Line 2",
            },
            {
              screenField: "Suburb",
              visible: false,
              dataField: "MailAddressSuburb",
              label: "Mail Suburb",
            },
            {
              screenField: "State",
              visible: false,
              dataField: "MailAddressState",
              label: "Mail State",
            },
            {
              screenField: "PostCode",
              visible: false,
              dataField: "MailAddressPostcode",
              label: "Mail Post Code",
            },
            {
              screenField: "Country",
              visible: false,
              dataField: "MailAddressCountry",
              label: "Mail Country",
            },
            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              // filterDataField: "FriendlyInactive",
              filterIndex: 0,
            },
          ],
        },
      };

      return config;
    },

    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          audit: true,
          save: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
              },
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                required: true,
                allowUpdate: this.baseView.mode == "edit" ? false : true,
                screenField: "Branch",
                isPrimaryKeyField: true,
                validationRules: [
                  {
                    type: "custom",
                    validationCallback: (e) => {
                      e.rule.message = `Branch Code only allow maximum length of 2 characters`;
                      return e.value.length < 3
                    },
                  },
                ],
              },
              {
                dataField: "Description",
                required: true,
                screenField: "Name",
              },

              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                  // value : true
                  // onInitialized: (e) => {
                  //   console.log('onInitialized 2');
                  // }
                },
                screenField: "IsDefault",
              },
            ],
          },
          {
            itemType: "group",
            caption: "Physical Address",
            colCount: 1,
            items: [
              {
                screenField: "PhysicalAddressStreetLine1",
                required: true,
              },
              {
                screenField: "PhysicalAddressStreetLine2",
              },
              {
                screenField: "PhysicalAddressSuburb",
                required: true,
              },
              {
                screenField: "PhysicalAddressState",
                required: true,
              },
              {
                screenField: "PhysicalAddressPostcode",
                required: true,
              },
              {
                screenField: "PhysicalAddressCountry",
                required: true,
              },
              {
                screenField: "SetAsPostalAddress",
                editorOptions: {
                  onValueChanged: (e) => {
                    if (!e.previousValue && e.value) {
                      this.resetPostalAddress();
                    }
                  },
                  onInitialized: (e) => {
                    if (!this.formModel["IsPostalData"]) {
                      e.component.beginUpdate();
                      e.component.option("value", this.getSetAsPostal());
                      e.component.endUpdate();
                    }
                  },
                  // hideCondition: {
                  //   itemType: "group",
                  //   caption: "Postal Address",
                  // },
                },
              },
            ],
          },
          {
            itemType: "group",
            caption: "Postal Address",
            colCount: 1,
            visible: this.setAsPostal,
            items: [
              {
                screenField: "MailAddressStreetLine1",
                required: true,
              },
              {
                screenField: "MailAddressStreetLine2",
              },
              {
                screenField: "MailAddressSuburb",
                required: true,
              },
              {
                screenField: "MailAddressState",
                required: true,
              },
              {
                screenField: "MailAddressPostcode",
                required: true,
              },
              {
                screenField: "MailAddressCountry",
                required: true,
              },
            ],
          },
        ],
      };

      return form;
    },
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setAsPostal() {
      return this.formModel["SetAsPostalAddress"] == true ? false : true;
    },
  },
  methods: {
    resetPostalAddress() {
      this.formModel["MailAddressStreetLine1"] = undefined;
      this.formModel["MailAddressStreetLine2"] = undefined;
      this.formModel["MailAddressSuburb"] = undefined;
      this.formModel["MailAddressState"] = undefined;
      this.formModel["MailAddressPostcode"] = undefined;
      this.formModel["MailAddressCountry"] = undefined;
    },
    getSetAsPostal() {
      this.formModel["IsPostalData"] = true;
      if (
        this.formModel["PhysicalAddressStreetLine1"] ==
          this.formModel["MailAddressStreetLine1"] &&
        this.formModel["PhysicalAddressStreetLine2"] ==
          this.formModel["MailAddressStreetLine2"] &&
        this.formModel["PhysicalAddressSuburb"] ==
          this.formModel["MailAddressSuburb"] &&
        this.formModel["PhysicalAddressState"] ==
          this.formModel["MailAddressState"] &&
        this.formModel["PhysicalAddressPostcode"] ==
          this.formModel["MailAddressPostcode"] &&
        this.formModel["PhysicalAddressCountry"] ==
          this.formModel["MailAddressCountry"]
      ) {
        this.formModel["SetAsPostalAddress"] = true;
        return true;
      } else {
        this.formModel["SetAsPostalAddress"] = false;
        return false;
      }
    },
  },
};
</script>
